import React from 'react';
import classnames from 'classnames';
import { Collapse } from '@mui/material';
import {
  FilterTypesKeys,
  FilterTypes,
  FilterOperators,
  FilterValueTypeOptions,
  TransformParameterTypes,
  boolValueOptions,
} from 'js/constants/schemaEditor';
import {
  SelectInput,
  SelectOption,
  getCurrentSelectedOption,
  getNewSelectionValue,
} from '../../rselect/ReactSelectUtils';
import UnsortedSelect from '../../rselect/UnsortedSelect';
import { TextField } from 'new/elements/TextField';
import { RemoveIconButton } from 'new/elements/Button/RemoveIconButton';

var _ = require('lodash');

class InspectorFilter extends React.Component {
  constructor(props) {
    super(props);

    this._onAddFilterClicked = this._onAddFilterClicked.bind(this);
    this._onDeleteFilterClicked = this._onDeleteFilterClicked.bind(this);
    this._onFilterValueChange = this._onFilterValueChange.bind(this);
    this._onFilterValueTypeChange = this._onFilterValueTypeChange.bind(this);
    this._onFilterAttributeChange = this._onFilterAttributeChange.bind(this);
    this._onFilterTypeSelectionChange = this._onFilterTypeSelectionChange.bind(this);
    this._onFilterOpChanged = this._onFilterOpChanged.bind(this);
    this._updateFilter = this._updateFilter.bind(this);
    this._renderFilterRows = this._renderFilterRows.bind(this);
  }

  _onAddFilterClicked() {
    const { filters, isExpanded, onExpand } = this.props;
    let numFilters = filters && !_.isEmpty(filters.parameters) ? filters.parameters.length : 0;

    if (numFilters > 0) {
      this._updateFilter(
        {
          type: TransformParameterTypes.FILTER_RULE,
          ruleOp: FilterTypesKeys.FILTER_NONE,
          ruleVal: { type: 'nullValue', value: null },
        },
        'addRule',
      );
    }

    if (!isExpanded) {
      onExpand();
    }
  }

  _onDeleteFilterClicked(index) {
    const { filters, onFilterChanged } = this.props;

    const newFilters = _.clone(filters);
    let numParams = newFilters.parameters.length;
    if (numParams === 2) {
      onFilterChanged(null);
    } else if (index === 0) {
      newFilters.parameters.splice(index, 2);
      onFilterChanged(newFilters);
    } else {
      newFilters.parameters.splice(index - 1, 2);
      onFilterChanged(newFilters);
    }
  }

  _onFilterValueChange(value, index) {
    //FormControl input could not handle null/undefined so we set it to blank.
    //Strip out the blank input value now .
    this._updateFilter({ ruleVal: { value: value } }, 'value', index);
  }

  _onFilterValueTypeChange(valueTypeSelection, index) {
    let valueType = getNewSelectionValue(valueTypeSelection, true);
    this._updateFilter({ ruleVal: { type: valueType } }, 'valueType', index);
  }
  _onFilterTypeSelectionChange(newFilterType, index) {
    const { filters } = this.props;
    const type = getNewSelectionValue(newFilterType, true);
    const ruleAttribute = filters.parameters[index]?.ruleAttribute;
    const filterType =
      !_.isNil(type) && _.has(FilterTypesKeys, type) ? type : FilterTypesKeys.FILTER_NONE;
    const defaultValue =
      FilterTypes[filterType].needsVal === true
        ? { type: 'string', value: '' }
        : {
            type: 'nullValue',
            value: null,
          };
    const update = {
      type: TransformParameterTypes.FILTER_RULE,
      ruleOp: filterType,
      ruleVal: defaultValue,
    };

    if (ruleAttribute) {
      update.ruleAttribute = ruleAttribute;
    }

    this._updateFilter(update, 'rule', index);
  }

  _onFilterAttributeChange(newAttr, index) {
    const attr = getNewSelectionValue(newAttr, true);
    this._updateFilter(attr, 'ruleAttribute', index);
  }

  _onFilterOpChanged(op, index) {
    this._updateFilter(
      { type: TransformParameterTypes.FILTER_RULE_JOIN_OP, value: op },
      'ruleOp',
      index,
    );
  }

  _updateFilter(update, updateType = 'rule', index) {
    const { filters, onFilterChanged } = this.props;
    let newFilters = filters
      ? filters
      : { type: TransformParameterTypes.FILTER_GROUP, parameters: [] };

    let paramsLength = newFilters.parameters.length;
    if (updateType === 'ruleOp' || updateType === 'rule') {
      if (_.isUndefined(index) || paramsLength <= index) {
        newFilters.parameters.push(update);
      } else {
        newFilters.parameters[index] = update;
      }
    } else if (updateType === 'value' || updateType === 'valueType') {
      let thisParam = newFilters.parameters[index];
      let newValue = { ...thisParam.ruleVal, ...update.ruleVal };

      if (newValue.type === 'number') {
        newValue.value = _.isFinite(_.toNumber(newValue.value)) ? _.toNumber(newValue.value) : 0;
      } else if (newValue.type === 'boolValue') {
        newValue.value = newValue.value === 'true' || newValue.value === 'TRUE';
      } else if (newValue.type === 'string') {
        newValue.value = _.toString(newValue.value);
      }
      newFilters.parameters[index] = { ...thisParam, ruleVal: newValue };
    } else if (updateType === 'ruleAttribute') {
      let thisParam = newFilters.parameters[index];
      newFilters.parameters[index] = { ...thisParam, ruleAttribute: update };
    } else if (updateType === 'addRule') {
      newFilters.parameters.push({
        type: TransformParameterTypes.FILTER_RULE_JOIN_OP,
        value: FilterOperators.AND,
      });
      newFilters.parameters.push(update);
    }

    if (newFilters.parameters.length === 0) {
      onFilterChanged(null);
    } else {
      onFilterChanged(newFilters);
    }
  }

  _renderFilterRows() {
    const { displayOptions, filters, outputSchema, isReadOnly, isInteractive, onRecipeClicked } =
      this.props;
    const fieldWrapperStyle = {
      flex: '1 1 0',
      minWidth: 0,
    };
    const attributeOptions = _.map(outputSchema, (attr) => ({
      label: attr.__txName,
      value: attr.__txName,
    }));

    if (
      !filters ||
      filters.type !== TransformParameterTypes.FILTER_GROUP ||
      _.isEmpty(filters.parameters)
    ) {
      let selectedFilterType = null;
      let idx = 0;
      return (
        <div key={idx}>
          <div
            style={{
              paddingRight: 'var(--spacing-md)',
              display: 'flex',
              alignItems: 'flex-end',
              marginBottom: 12,
              width: '100%',
            }}
          >
            <div
              style={{
                ...fieldWrapperStyle,
                maxWidth: 186,
              }}
            >
              <div
                style={{
                  height: 18,
                  lineHeight: '18px',
                  fontSize: 11,
                }}
              >
                Attribute
              </div>
              <UnsortedSelect
                isCreatable={true}
                options={attributeOptions}
                components={{ Input: SelectInput, Option: SelectOption }}
                isSearchable={true}
                isClearable={true}
                backspaceRemovesValue={false}
                value=""
                variant="default"
                maxMenuHeight={120}
                onChange={(newAttr) => {
                  this._onFilterAttributeChange(newAttr, idx);
                }}
              />
            </div>
            <div
              style={{
                ...fieldWrapperStyle,
                paddingLeft: 'var(--spacing-sm)',
                maxWidth: 186,
              }}
            >
              <div
                style={{
                  height: 18,
                  lineHeight: '18px',
                  fontSize: 11,
                }}
              >
                Criteria
              </div>
              <UnsortedSelect
                options={displayOptions}
                components={{ Input: SelectInput, Option: SelectOption }}
                isSearchable={true}
                isClearable={true}
                backspaceRemovesValue={false}
                variant="default"
                name="filterSelect"
                value={selectedFilterType}
                maxMenuHeight={120}
                onChange={(newType) => {
                  this._onFilterTypeSelectionChange(newType, idx);
                }}
              />
            </div>
          </div>
        </div>
      );
    }

    let filterRowViews = _.map(filters.parameters, (rule, idx) => {
      let isJoinOp = rule.type === TransformParameterTypes.FILTER_RULE_JOIN_OP || idx % 2 === 1;
      let isNoFilterRule =
        rule.type === TransformParameterTypes.FILTER_RULE && rule.ruleOp === 'FILTER_NONE';

      if (isJoinOp) {
        let selectedOp = rule.value;
        return (
          <div
            key={idx}
            style={{
              position: 'relative',
            }}
          >
            <div
              style={{
                position: 'absolute',
                width: 20,
                height: 45.5,
                top: -32,
                left: -20,
                border: '2px solid #454545',
                borderRightStyle: 'none',
                borderBottomStyle: 'none',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  position: 'relative',
                  left: -18,
                  top: 14,
                }}
              >
                <button
                  className={classnames('op-button', {
                    selected: selectedOp === FilterOperators.AND,
                  })}
                  disabled={isReadOnly}
                  onClick={() => {
                    this._onFilterOpChanged(FilterOperators.AND, idx);
                  }}
                >
                  and
                </button>
                <button
                  className={classnames('op-button', {
                    selected: selectedOp === FilterOperators.OR,
                  })}
                  disabled={isReadOnly}
                  onClick={() => {
                    this._onFilterOpChanged(FilterOperators.OR, idx);
                  }}
                >
                  or
                </button>
              </div>
            </div>
          </div>
        );
      }

      let showHeadings = idx === 0 && !isReadOnly;
      let selectedAttribute = rule.ruleAttribute
        ? getCurrentSelectedOption(attributeOptions, rule.ruleAttribute, null, null, true)
        : null;
      let selectedFilterType =
        !isNoFilterRule || rule.ruleOp === FilterTypes.FILTER_NONE
          ? FilterTypes[rule.ruleOp]
          : null;
      let filterValueType =
        selectedFilterType && selectedFilterType.needsVal && _.has(rule, 'ruleVal.type')
          ? getCurrentSelectedOption(FilterValueTypeOptions, rule.ruleVal.type)
          : null;

      const boolValue =
        filterValueType?.value === 'boolValue'
          ? getCurrentSelectedOption(boolValueOptions, `${rule.ruleVal.value}`)
          : null;

      if (isReadOnly) {
        return (
          <li
            key={idx}
            className={classnames('filter-item is-blurred', {
              'is-read-only': isReadOnly && !isInteractive,
            })}
            onClick={() => {
              if (isReadOnly && isInteractive) {
                onRecipeClicked(idx);
              }
            }}
          >
            <span className="schema-validation-rule-description">
              <span className="attr-name">{selectedAttribute?.label}</span>{' '}
              {_.toLower(selectedFilterType?.label)}
              {selectedFilterType?.needsVal && (
                <>
                  {' '}
                  <span className="attr-name">{`${rule?.ruleVal?.value}`}</span>
                </>
              )}
              .
            </span>
          </li>
        );
      }

      return (
        <div key={idx}>
          <div
            style={{
              paddingRight: 'var(--spacing-md)',
              display: 'flex',
              alignItems: 'flex-end',
              marginBottom: 12,
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                flexGrow: 1,
                width: '100%',
              }}
            >
              <div
                style={{
                  ...fieldWrapperStyle,
                  maxWidth: 186,
                }}
              >
                {showHeadings && (
                  <div
                    style={{
                      height: 18,
                      lineHeight: '18px',
                      fontSize: 11,
                    }}
                  >
                    Attribute
                  </div>
                )}
                <UnsortedSelect
                  isCreatable={true}
                  options={attributeOptions}
                  components={{ Input: SelectInput, Option: SelectOption }}
                  isSearchable={true}
                  isClearable={true}
                  backspaceRemovesValue={false}
                  value={selectedAttribute}
                  variant="default"
                  maxMenuHeight={120}
                  onChange={(newAttr) => {
                    this._onFilterAttributeChange(newAttr, idx);
                  }}
                />
              </div>
              <div
                style={{
                  ...fieldWrapperStyle,
                  maxWidth: 186,
                  paddingLeft: 'var(--spacing-sm)',
                }}
              >
                {showHeadings && (
                  <div
                    style={{
                      height: 18,
                      lineHeight: '18px',
                      fontSize: 11,
                    }}
                  >
                    Criteria
                  </div>
                )}
                <UnsortedSelect
                  options={displayOptions}
                  components={{ Input: SelectInput, Option: SelectOption }}
                  isSearchable={true}
                  isClearable={true}
                  backspaceRemovesValue={false}
                  name="filterSelect"
                  value={selectedFilterType}
                  variant="default"
                  maxMenuHeight={120}
                  onChange={(newType) => {
                    this._onFilterTypeSelectionChange(newType, idx);
                  }}
                />
              </div>
              {selectedFilterType && selectedFilterType.needsVal && (
                <div
                  style={{
                    ...fieldWrapperStyle,
                    paddingLeft: 'var(--spacing-sm)',
                  }}
                >
                  {showHeadings && (
                    <div
                      style={{
                        height: 18,
                        lineHeight: '18px',
                        fontSize: 'var(--font-size-base-sm)',
                      }}
                    >
                      Value
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        ...fieldWrapperStyle,
                        maxWidth: 186,
                      }}
                    >
                      <UnsortedSelect
                        style={{ width: '100%' }}
                        options={FilterValueTypeOptions}
                        components={{
                          Input: SelectInput,
                          Option: SelectOption,
                        }}
                        isSearchable={true}
                        isClearable={false}
                        backspaceRemovesValue={false}
                        name="filterSelect"
                        variant="default"
                        maxMenuHeight={120}
                        value={filterValueType || null}
                        onChange={(newType) => {
                          this._onFilterValueTypeChange(newType, idx);
                        }}
                      />
                    </div>
                    {filterValueType?.value === 'boolValue' ? (
                      <div
                        style={{
                          ...fieldWrapperStyle,
                          maxWidth: 186,
                          marginLeft: 'var(--spacing-sm)',
                        }}
                      >
                        <UnsortedSelect
                          style={{ width: '100%' }}
                          options={boolValueOptions}
                          components={{
                            Input: SelectInput,
                            Option: SelectOption,
                          }}
                          isSearchable={false}
                          isClearable={false}
                          backspaceRemovesValue={false}
                          name="boolValueSelect"
                          variant="default"
                          maxMenuHeight={120}
                          value={boolValue}
                          onChange={(option) => {
                            this._onFilterValueChange(option.value, idx);
                          }}
                        />
                      </div>
                    ) : (
                      <TextField
                        variant="filled"
                        fullWidth
                        formControlStyle={{
                          marginLeft: 4,
                          ...fieldWrapperStyle,
                          maxWidth: 186,
                          background: 'white',
                        }}
                        InputProps={{
                          sx: { width: '100%' },
                        }}
                        value={`${rule.ruleVal.value}`}
                        onChange={(event) => {
                          this._onFilterValueChange(event.target.value, idx);
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            <RemoveIconButton
              onClickRemove={(e) => {
                e.stopPropagation();
                this._onDeleteFilterClicked(idx);
              }}
              tooltipText="Remove Rule"
              className={classnames('delete-icon', {
                invisible: filters.parameters.length <= 1,
              })}
            />
          </div>
        </div>
      );
    });

    return filterRowViews;
  }

  render() {
    const { filters, isReadOnly, isExpanded } = this.props;
    const filterRows = this._renderFilterRows();
    const hasMultipleFilters = filters?.parameters?.length > 1;

    return (
      <div className="inspector-filter">
        <div
          style={{
            paddingLeft: hasMultipleFilters && isExpanded ? 30 : 0,
          }}
        >
          <Collapse in={isExpanded}>
            {isReadOnly ? (
              <div className="schema-validations-editor">
                <ul className="filters-list">{filterRows}</ul>
              </div>
            ) : (
              filterRows
            )}
          </Collapse>
          <div
            style={{
              position: 'relative',
            }}
          >
            {hasMultipleFilters && isExpanded && (
              <div
                style={{
                  position: 'absolute',
                  width: 20,
                  height: 46.5,
                  top: -33,
                  left: -20,
                  border: '2px none #454545',
                  borderTopStyle: 'solid',
                }}
              />
            )}
            {!isReadOnly && (
              <button className="add-recipe-button" onClick={this._onAddFilterClicked}>
                + Add New Filter
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default InspectorFilter;
